module.exports = __webpack_public_path__ + "img/rapido-white.938e005.svg";